import { connect } from 'react-redux'
import { compose, withHandlers, withProps, withState } from 'recompose'
import { bindActionCreators } from 'redux'

import * as InboxActions from 'app/modules/inbox/actions'
import * as InboxSelectors from 'app/modules/inbox/selectors'

import Domain from './component'

const mapStateToProps = (state, props) => ({
  isOpen: InboxSelectors.isWhitelabelOpen(state, props.whitelabel.get('domain')),
  verifyPending: InboxSelectors.isVerifyPending(state, { domain: props.whitelabel.get('id') }),
  verifySuccess: InboxSelectors.isVerifySuccess(state, { domain: props.whitelabel.get('id') }),
  verifyFailed: InboxSelectors.isVerifyFailed(state, { domain: props.whitelabel.get('id') }),
})


const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    verifySendingDomain: InboxActions.verifySendingDomain,
    openWhitelabelDKIMSetting: InboxActions.openWhitelabelDKIMSetting,
    closeWhitelabelDKIMSetting: InboxActions.closeWhitelabelDKIMSetting,
    deleteSendingDomain: InboxActions.deleteSendingDomain,
  }, dispatch)
})


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => ({
    isVerified: props.whitelabel.get('status') === 'VERIFIED',
  })),
  withState('isDeletingDomain', 'setIsDeletingDomain', false),
  withHandlers({
    toggleActive: props => () => {
      const domain = props.whitelabel.get('domain')
      props.isOpen ? props.actions.closeWhitelabelDKIMSetting({ domain }) : props.actions.openWhitelabelDKIMSetting({ domain })
    },
    onVerifyClick: props => () => {
      props.actions.verifySendingDomain({ domain: props.whitelabel.get('id') })
    },
    onDeleteClick: props => (e) => {
      const { isDeletingDomain } = props
      props.setIsDeletingDomain(!isDeletingDomain)
      props.actions.deleteSendingDomain({ domain: props.whitelabel.get('id') })
    },
    toggleDeleteModal: props => (e) => {
      const { isDeletingDomain } = props
      e.stopPropagation()
      props.setIsDeletingDomain(!isDeletingDomain)
    },
  })
)(Domain)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/DKIMEmailSettings/Domain/index.js